<template>
    <div class="topbg">
        <div class="topleft">
            <!-- <a href="/" target="_parent">
                <div id="logo" width="98" height="40"></div>
            </a> -->
            <div id="logo" style="margin-top: 24px;"></div>
        </div>
        <ul class="nav">
            <li><a href="/desktop" target="rightFrame" class="selected"><img src="../assets/images/work3.png" title="工作台" /><h2>工作台</h2></a></li>
            <li><a href="/userpackage" target="rightFrame"><img src="../assets/images/icon02.png" title="业务订购" /><h2>业务订购</h2></a></li>
            <li v-if="userType !='智语网络'"><a href="/fee"  target="rightFrame"><img src="../assets/images/icon03.png" title="资费表" /><h2>资费表</h2></a></li>
            <!-- <li><a href="/chargeaccount"  target="_blank"><img src="../assets/images/icon04.png" title="充值" /><h2 style="color:#fcfdfd;">充值</h2></a></li> -->
            <li v-if="userType !='智语网络'"><a href="/chargeaccount"  target="_blank"><img src="../assets/images/charge004.png" title="充值" /><h2 style="color:#fcfdfd;">充值</h2></a></li>
            <li><a href="/account" target="rightFrame"><img src="../assets/images/icon05.png" title="余额" /><h2>余额</h2></a></li>
            <li v-if="userType !='智语网络'"><a href="/youhui"  target="rightFrame"><img src="../assets/images/icon06.png" title="优惠活动" /><h2>优惠活动</h2></a></li>
            <li><a href="/kefuindex"  target="_blank"><img src="../assets/images/icon07.png" title="联系客服" /><h2>联系客服</h2></a></li>
        </ul>

        <div style="width:485px; overflow:hidden;  position: fixed; right:180px; background:#fcfdfd;box-shadow:1px 8px 10px 1px #9b9b9b;
            border-radius:1px; display:block; z-index:199;" v-show="showMessage">
            <template v-if="messageRecordNum > 0">
                <div class="tiptop"><span>消息</span><a @click="closeMessage()"></a></div>
                <div class="tipinfo1" style="position: relative;">
                    <ul>
                        <li v-for="(item, index) in list" class="litan">
                            <div style="clear:both;overflow: hidden;">
                                <a class="left c3186c8" @click="showContent(index, item.account)" style="cursor: pointer;">{{item.msgTitle}}</a>
                                <template v-if="item.account != '*'">
                                    <a class="right ml20 c3186c8" style="cursor: pointer;" @click="delsystemmessage(item.id)">删除</a>
                                </template>
                                <span class="right f666">{{item.createTime}}</span>
                            </div>
                            <div v-show="show === index ? true : false">
                                <!-- <template v-if="item.account == '*'">
                                    <label class="c3186c8" style="color: red;">{{item.msgContent}}</label>
                                </template> -->
                                <template v-if="item.account != '*'">
                                    <label class="c3186c8" style="color: red;">{{item.msgContent}}</label>
                                    <!-- <a class="right ml20 c3186c8" style="cursor: pointer;" @click="updatesystemmessage(item.id)">标记为已读</a> -->
                                </template>
                                <template v-else>
                                    <label class="c3186c8" style="color: red;">{{item.msgContent}}</label>
                                </template>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="cen b3186c8">
                    <a class="ml20 c3186c8" style="cursor: pointer;color:white;" href="/showallsystemmessage" target="rightFrame" @click="closemessage()">查看全部</a>
                </div>
            </template>
            <template v-else>
                <div class="tiptop"><span>消息</span><a @click="closeMessage()"></a></div>
                <div class="tipinfo1" style="position: relative;">
                    <ul>
                        <li class="litan">
                            <div style="clear:both;overflow: hidden;">
                                <span style="color:red;text-align: center;">暂无未处理消息</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="cen b3186c8">
                    <a class="ml20 c3186c8" style="cursor: pointer;color:white;" href="/showallsystemmessage" target="rightFrame" @click="closemessage()">查看全部</a>
                </div>
            </template>
        </div>

        <div class="topright">    
            <ul>
                <!-- <li><span><img src="../assets/images/help.png" title="帮助" class="helpimg"/></span><a href="javascript:;" @click="help()">帮助</a></li> -->
                <li><a href="/message" target="rightFrame">投诉建议</a></li>
                <li><a href="javascript:;" target="_parent" @click="loginout()">退出</a></li>
            </ul>
        
            <div class="user" style="margin-right: 30px;">
                <span style="margin-left: 15px;">
                    <ol v-if="vip != ''" style="float:left;color:red; font-size:14px;">
                        <!-- VIP:{{vip}}
                        &nbsp;&nbsp; -->
                        <template v-if="vip == 1">
                            <img v-if="isExpired == 0"  src="../assets/images/vip01.png" width="50px" height="20px" style="vertical-align: middle;" :title="imgTitle" />
                            <a v-else href="/vipcharge" target="_blank" ><img  src="../assets/images/vip1.png" width="50px" height="20px" style="vertical-align: middle;" :title="imgTitle" /></a>
                        </template>
                        <template v-else-if="vip == 2">
                            <img v-if="isExpired == 0"  src="../assets/images/vip02.png" width="50px" height="20px" style="vertical-align: middle;" :title="imgTitle" />
                            <a v-else href=""><img  src="../assets/images/vip2.png" width="50px" height="20px" style="vertical-align: middle;" :title="imgTitle" /></a>
                        </template>
                        <template v-if="vip == 3">
                            <img v-if="isExpired == 0"  src="../assets/images/vip03.png" width="50px" height="20px" style="vertical-align: middle;" :title="imgTitle" />
                            <a v-else href=""><img  src="../assets/images/vip3.png" width="50px" height="20px" style="vertical-align: middle;" :title="imgTitle" /></a>
                        </template>
                    </ol>
                    门牌号:<a href="personinfo" target="rightFrame" style="font-size:13px;color:white;">
                        {{this.account}}
                    </a>
                    <el-tooltip class="item" effect="dark" content="查看消息" placement="top-start">
                        <div class="right click" @click="doing()" style="margin-left:10px;cursor: pointer;">
                            <b>{{messageRecordNum}}</b>
                        </div>
                    </el-tooltip>
                </span>
            </div>
        </div>
    </div>

</template>
<style>
  .topbg{
      background:url(../assets/images/topbg.gif) repeat-x;
      width: 100%;
      height: 88px;
  }
</style>
<script>
import { setCookie,getCookie,delCookie } from '../assets/js/cookie.js'
export default {
    data(){
        return{
            account:'',
            cpid: '',
            vip:'',
            list: [],
            allsystemmessageList: [],
            usersystemmessageList: [],
            messageRecordNum: 0,
            show: 99,
            showMessage: true,
            userType:'',
            expiredtime:'',
            imgTitle:'',
            isExpired:0,
        }
    },
    mounted(){
        let token = getCookie('2officesessionid')
        if(token == ""){
            this.$router.push('/')
            return
        }
        this.GLOBAL.token = token
        this.userinfo();
        this.getsystemmessage();
    },
    methods:{
        getsystemmessage() {
            var that = this;
            let param = {'flag': 'some', 'pageIndex': 1, 'pageSize': 5}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/top/showsystemmessage.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token,
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.allsystemmessageList = res.data.allsystemmessageList;
                    that.list = that.allsystemmessageList.concat(res.data.usersystemmessageList)
                    // that.usersystemmessageList = res.data.usersystemmessageList;
                    that.messageRecordNum = res.data.messageRecordNum;
                }
                else
                {
                    that.$alert(res.data.msg)
                }
            })
        },
        doing() {
            // $(".click").live('click',function(){
            //     $(".tipxx").fadeIn(200);
            // });
            // $(".tiptop a").click(function(){
            //     $(".tipxx").fadeOut(200);
            // });
            if(this.showMessage)
            {
                this.showMessage = false;
            }
            else
            {
                this.showMessage = true;
            }
        },
        userinfo(){
            let that = this
            // let param = aes.Encrypt(JSON.stringify({}))
            let param = {}
            this.$ajax({                
                method: 'post',
                url: this.GLOBAL.serverSrc + '/main/headinfo.json',
                data: param,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token': this.GLOBAL.token,
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.account = res.data.account;
                    that.cpid = res.data.cpid;
                    that.vip = res.data.vip;
                    that.expiredtime = res.data.expiredtime;
                    
                    that.userType = res.data.userType;
                    that.isExpired = res.data.isExpired;
                    if(that.isExpired == 1){
                        that.imgTitle = '有效期至:' + res.data.expiredtime+"，点击去续费";
                    }else{
                        that.imgTitle = '有效期至:' + res.data.expiredtime;
                    }
                }
            })
        },
        loginout() {
            var that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/top/loginout.json",
                data:data,
                headers: {
                    'Content-Type': "application/json;charset=UTF-8",
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    setCookie("2officesessionid", res.data.token, 60*60*10);
                    delCookie('2officesessionid');
                    that.$router.push('/');
                }
                else
                {
                    delCookie('2officesessionid');
                    that.$router.push('/');
                }
            })
        },
        help() {
            window.open ('kefuindex', 'newwindow');
        },
        showContent(index, account) {
            if(this.show != index)
            {
                this.show = index;
            }
            else
            {
                this.show = 99;
            }
            if(this.list[index].state == 0 && '*' != account)
            {
                this.updatesystemmessage(this.list[index].id);
                this.list[index].state = 1;
            }
            
        },
        updatesystemmessage(id) {
            var that = this;
            let param = {'id': id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/top/updatesystemmessage.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    // that.$message.success("消息已读!");
                    // that.show = 99;
                    // that.getsystemmessage();
                    that.messageRecordNum = that.messageRecordNum - 1;
                }
                else
                {
                    that.$alert(res.data.msg)
                    return false;
                }
            })
        },
        delsystemmessage(id) {
            this.$confirm("确定删除系统消息？", '提示', {
                confirmButtonText: '确定', 
                cancelButtonText: '取消',                               
                type: 'warning'
            }).then( () => {
                var that = this;
                let param = {'id': id};
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + "/top/deletesystemmessage.json",
                    data: param,
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'token': this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.$message({
                            type: 'success',
                            message: "删除系统消息成功"
                        });
                        that.show = 99;
                        that.getsystemmessage();
                    }
                    else
                    {
                        that.$message({
                            type: 'error',
                            message: res.data.msg
                        });
                        return false;
                    }
                })
            }).catch( () => {
                this.$message({
                    duration: 2000,
                    showClose: true,
                    type: 'error',
                    message: '取消'
                });
            });
        },
        closemessage() {
            this.show = 99;
            $(".tipxx").fadeOut(200);
            this.showMessage = false;
        },
        closeMessage() {
            this.show = 99;
            $(".tipxx").fadeOut(200);
            this.showMessage = false;
        },
        goVipCharge(vipgrade, expiredtime){
            // console.log(mobile+',' + content+',' + format+',' +  mobileNum+',' + srcfilename)
            this.$router.push({
                path: '/vipcharge',
                query: {
                    vipgrade: vipgrade,
                    expiredtime: expiredtime
                }
            })
            
            
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/top.vue